import ApiService from "@/api";
import { ResponseModel, SaveTeamModel, UserModel } from "../models";
import {
  mapGetEmployeesResponse,
  mapGetOwnedUsersResponse,
  mapGetTeamRequest,
  mapGetTeamResponse,
  mapSaveTeamRequest,
} from "./AdapterServiceMappers";
import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";
import EnumUserStatus from "@/api/Main/dataSource/api/users/base/enums/EnumUserStatus";
import GetOwnedUsersWithAccessRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetOwnedUsersWithAccessRequest";
import GetEmployeesForManagerListWithAccessRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetEmployeesForManagerListWithAccessRequest";

export class NamespaceQueuesAdapterService {
  private readonly api = new ApiService();

  /**
   * * Получить список команды
   * @param namespaceId ID неймспейса
   * @returns
   */
  getTeam(namespaceId: string) {
    return new Promise<ResponseModel<Array<UserModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<UserModel>>();

      await this.api.Main.ProjectNamespaceService.getNamespaceByIdAsync(
        mapGetTeamRequest(namespaceId),
      )
        .then((resp) => {
          result.Value = mapGetTeamResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getTeam", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Сохранить команду
   * @param request Запрос
   * @returns
   */
  saveTeam(request: SaveTeamModel) {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      await this.api.Main.NamespaceAdminRoleService.upsertNamespaceEmployeeListAsync(
        mapSaveTeamRequest(request),
      )
        .then((resp) => {
          result.Value = true;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR saveTeam", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список пользователей и краткую информацыю о них
   * @returns
   */
  private getOwnedUsers(projectId?: number, namespaceId?: string) {
    return new Promise<ResponseModel<Array<UserModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<UserModel>>();

      await this.api.Main.PerformersListService.getOwnedUsersWithAccessAsync(
        new GetOwnedUsersWithAccessRequest({
          Page: new PageRequest({ Skip: 0, Take: 1000 }),
          Search: "",
          StatusList: [EnumUserStatus.Active],
          ProjectId: projectId,
          NamespaceId: namespaceId
        }),
      )
        .then((resp) => {
          result.Value = mapGetOwnedUsersResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getOwnedUsers", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Получить список сотрудников текущего пользователя
   * @returns
   */
  private getEmployeesForManagerList(projectId?: number, namespaceId?: string) {
    return new Promise<ResponseModel<Array<UserModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<UserModel>>();

      await this.api.Main.EmployeeService.getEmployeesForManagerListWithAccessAsync(
        new GetEmployeesForManagerListWithAccessRequest({
          Page: new PageRequest({ Skip: 0, Take: 1000 }),
          Statuses: [EnumUserStatus.Active],
          ProjectId: projectId,
          NamespaceId: namespaceId
        }),
      )
        .then((resp) => {
          result.Value = mapGetEmployeesResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getEmployeesForManagerList", e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получить список сотрудников текущего пользователя
   * @returns
   */
  getEmployees(projectId?: number, namespaceId?: string) {
    if (CurrentUser.Roles.includes(UserRoleEnum.Owner)) return this.getOwnedUsers(projectId, namespaceId);
    return this.getEmployeesForManagerList(projectId, namespaceId);
  }
}
